import axios from "axios";
import appConfig from "../assests/config";
import { getLocalStorage } from "./storage";
import { Buffer } from "buffer";
class ApiService {
    constructor() {
        this.axiosInstance = axios.create();
    }
    get({ URL, disableConfig, brand }) {
        let _confg = this.getConfig({ disableConfig, brand });
        return this.axiosInstance.get(URL, _confg);
    }
    post({ URL, data, disableConfig, brand, headers }) {
        let _confg = this.getConfig({ disableConfig, brand, headers });
        return this.axiosInstance.post(URL, data, _confg);
    }
    getConfig({ disableConfig, brand, headers, }) {
        if (disableConfig)
            return {};
        let config = {
            headers: Object.assign({}, headers),
        };
        if (brand && !(brand === null || brand === void 0 ? void 0 : brand.toLowerCase().includes(appConfig.uhf))) {
            // Creating base64 value with netwell name & date
            const bufferParam = `${brand.toUpperCase()};${new Date()}`;
            const base64 = Buffer.from(bufferParam).toString("base64");
            config.headers = Object.assign(Object.assign({}, config.headers), { "X-Tenant-Id": base64 });
        }
        config.headers.Authorization = "Bearer " + getLocalStorage("bearerToken");
        return config;
    }
}
export default new ApiService();
